var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard4Clubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000046316852199875376130000018319985222635735459_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.7 C309.5,6.6,302.9,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.7,296.6c0,18.3,5,36.6,6.8,42.3c0.3,1-0.4,1.9-1.4,1.9h-55c-1,0-1.7-0.9-1.4-1.9c1.7-5.8,6.8-24.3,6.8-42.4 c-7.3,5.3-15.7,8-25,8c-26.9,0-50.3-22.6-48.6-49.9c0.9-15.3,10.7-28.5,23.7-36.7c13.1-8.2,25.2-8.9,36-6.2 c-6.9-8.2-11.1-18.8-11.1-30.4c0-29.1,26.4-52,56.5-46.2c18.9,3.6,33.8,19.1,37,38.1c2.5,14.7-1.9,28.4-10.4,38.5 c10.9-2.6,23.1-2,36.3,6.4c13,8.2,22.7,21.4,23.6,36.7c1.6,27.2-21.9,49.7-48.8,49.7C192.5,304.6,183.9,301.7,176.7,296.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,84c-2.4,3.3-1.8,7.9,1.5,10.3s7.9,1.8,10.3-1.5l44.2-59c2.4-3.3,1.8-7.9-1.5-10.3s-7.9-1.8-10.3,1.5L23.5,84z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3,117.9c0,4.1,3.3,7.4,7.4,7.4s7.4-3.3,7.4-7.4V29.5c0-4.1-3.3-7.4-7.4-7.4s-7.4,3.3-7.4,7.4V117.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,81c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h59c4.1,0,7.4-3.3,7.4-7.4S92.5,81,88.4,81H29.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4,125.2c4.1,0,7.4-3.3,7.4-7.4s-3.3-7.4-7.4-7.4H58.9c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4H88.4z"
  })), /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.3,370.5c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S289.3,350.1,289.3,370.5z  M252.5,340c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4c16.8,0,30.4-13.6,30.4-30.4S269.3,340,252.5,340z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277.2,363.7c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C271.5,351.5,277.2,357.1,277.2,363.7z M272.2,363.7c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C268.7,371.2,272.2,367.9,272.2,363.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M261.5,386.7c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C258.5,380.4,261.5,383.2,261.5,386.7z  M257.3,386.7c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C256.1,389.3,257.3,388.2,257.3,386.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7,359.9c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C247.6,361.1,246.3,359.9,244.7,359.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8,379.8c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S236.4,379.8,234.8,379.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.5,383.5c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C273.5,384.8,272.1,383.5,270.5,383.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 252.5,
    cy: 370.5,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052790087664097876050000015276399916753753736_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000052790087664097876050000015276399916753753736_)"
    },
    d: "M241.9,350.7 c-0.2,3.5-3.4,6.2-7.2,6c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C239.3,344.2,242.1,347.3,241.9,350.7z M237.7,350.5 c0.1-1.4-1-2.6-2.5-2.7c-1.5-0.1-2.7,1-2.8,2.4c-0.1,1.4,1,2.6,2.5,2.7C236.4,353,237.6,351.9,237.7,350.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4Clubs);
export default __webpack_public_path__ + "static/media/card_4-clubs.7122e639b1dff57f900bbe215d9dd0ae.svg";
export { ForwardRef as ReactComponent };